import { render, staticRenderFns } from "./ImageWidth.vue?vue&type=template&id=4c8da8bc&"
import script from "./ImageWidth.vue?vue&type=script&lang=js&"
export * from "./ImageWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports